import { useCustomerAnalytics } from "../../../../services/hooks/useCustomerAnalytics";
import { useTranslationI18 } from "../../../../services/hooks/useTranslationI18";
import { CUSTOMER_ANALYTICS_EVENT } from "../../../../utils/enums";
import { StarIcon } from "../../S-Pay/PayScreen.icons";
import card from "./OrderCardV2.module.scss";

type OrderRateRowProps = {
  orderId: number;
  hasFeedback: boolean;
  openFeedbackModal: (receiptId: number, initialStar?: number) => void;
  firstStarTestId?: string;
};

export const OrderRateRow = ({
  orderId,
  hasFeedback,
  openFeedbackModal,
  firstStarTestId,
}: OrderRateRowProps) => {
  const { t } = useTranslationI18();
  const addCustomerAnalytics = useCustomerAnalytics();

  const handleRateClick = (star: number) => {
    addCustomerAnalytics(CUSTOMER_ANALYTICS_EVENT.RATE_FROM_PREVIOUS_ORDERS);
    openFeedbackModal(orderId, star);
  };

  if (hasFeedback) {
    return null;
  }

  return (
    <div className={card.rate_row}>
      <span className={card.rate_row_label}>{t("common:rate-your-order")}</span>
      <div className={card.rate_row_stars}>
        {[1, 2, 3, 4, 5].map((i) => (
          <button
            key={i}
            type="button"
            className={card.rate_row_star_button}
            onClick={() => handleRateClick(i)}
            data-testid={i === 1 ? firstStarTestId : undefined}
            aria-label={`Rate with ${i} star${i > 1 ? "s" : ""}`}
          >
            <StarIcon size={20} />
          </button>
        ))}
      </div>
    </div>
  );
};
